import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/atc/ATC CREAM chocolate.png";
import BiscuitImg from "../../../assets/products/atc/ATC-Chocolate.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 125,
  },
  {
    grams: 150,
  },
];

export default function ChcolateATCProduct() {
  return (
    <>
      <Helmet>
        <title>
          ATC Chocolate Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz ATC Chocolate Cream Biscuits — premium chocolate-flavored cream biscuits in ATC format. View pack sizes and global specifications."
        />
        <meta
          name="keywords"
          content="ATC Chocolate Cream Biscuit, BearBitz ATC Chocolate"
        />
        <link rel="canonical" href="https://www.www.bearbitz.in/atc/chocolate" />
        <meta
          property="og:title"
          content="ATC Chocolate Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Chocolate cream biscuit in ATC format with export-level packaging and premium quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="CHOCOLATE"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in The rich taste of ATC Cream Biscuits, where every crunchy bite meets a smooth and creamy filling."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#683B1E"
        sectionBgColor="#FFC158"
        productBgcolor="#FFECCB"
        tableheadBgcolor="#6A3E20"
        tableBgcolor="#F8EBE3"
        footerBgcolor="#6A3E20"
      />
    </>
  );
}
